/**
 * Market survey params that the form never changes. Kept identical to what
 * the original Report Request sends so V2 reports are indistinguishable to conch.
 */
export const MARKET_SURVEY_CONSTANTS = {
  max_num_texture_allowed: null,
  texture_weight_threshold_list: 2,
  refresh_texture: false,
  texture_community_path: null,
  n_review_archetype: 2,
  n_review_archetype_max: 5,
  min_unique_reviewers: 20,
  n_cluster_archetype: 2,
  n_cluster_archetype_max: 6,
  arch_age_start: [20, 30, 40, 50, 60],
  include_market_maps: true,
  include_pairwise_comparison: true,
  include_gradients: true,
  apply_margEffect_ggvar_range: true,
  maxRowSummaryTable: 30,
  maxRowDecomSubTable: 20,
  minReviews: 5,
  alcoholLegal: false,
  apply_doofus_factor: true,
  new_reference_flavors_allowed: false,
  is_opt_test_mode: false,
  hot_patch_post_label_prop_data: false,
  extrema_analysis: true,
  simulate_pq_values: false,
  n_sims: [150, 200],
  selected_product_ids: null,
  product_rename: null,
  supplement_competitive_set_products: false,
  competitive_set_base_components: null,
  competitive_set_other_components: null,
  competitive_set_components_categories_allowed: null,
  products_to_opt: null,
  constraint_levels: ['HC', 'MC', 'LC'],
  parallelCode: true,
  opt_file_to_load: null,
  concept_base_products: null,
  ref_flavors_to_explore: null,
  region: null,
  experience_range: [1, 2, 3],
  age_filtering_list: null,
  glp_s3_key: 'data/global_label_prop.csv',
  glp_s3_bucket: 'gastrograph-argo-artifacts',
  post_label_prop_data_path: 'N/A',
  latest_date: null,
  archetype_seed: null,
  demo_id_path: null,
  PQ_model_path: null,
  ref_flavor_path: null,
  archetype_PQ_model_path: null,
  archetype_list_path: null,
  explode_and_remove_refFlavors: null,
  pull_glp_from_s3: true,
  show_pg_gNorm: false,
  plotTextureGradients: false,
  timestamp_start: null,
  slack_me: true,
};
